import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DeveloperInsightSectionComponent } from '../developer-insight-section';

@Component({
  selector: 'app-developer-traffic-quality',
  templateUrl: './developer-traffic-quality.component.html',
  styleUrls: [
    './developer-traffic-quality.component.scss',
    '../developer-insight-section.scss'
  ],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DeveloperTrafficQualityComponent extends DeveloperInsightSectionComponent {
  riskOverview: any;
  trafficQuality: any;

  constructor() {
    super();
    this._developerStateService.developer$.subscribe(data => {
      this.riskOverview = data?.riskOverview;
      this.trafficQuality = data?.trafficQuality;
    });
  }
}
